import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
const UPDATE_LABS = "UPDATE_LABS";
const UPDATE_SESSIONS = "UPDATE_SESSIONS";
const UPDATE_FILECACHE = "UPDATE_FILECACHE";
const API_ERROR = "API_ERROR";
const API_ENDPOINT = "https://finalprojects.fabacademy.org";
const SESSIONS_URL = API_ENDPOINT + "/api/schedule/sessions";
const LABS_URL = API_ENDPOINT + "/api/schedule/labs";
// const FILE_EXISTS_URL = API_ENDPOINT + "/api/filecheck";
const THUMB_URL = API_ENDPOINT + "/api/thumbs";

const IDS = {
  "2026": "696d795602eeb6b4020eb5d5",
  "2025": "678db1355c66af7ecfaecaf1",
  "2024": "65a7da69efef6f2a5c2ad418",
  "2023": "63cfa200b23252468c1af0d4",
  "2022": "61e68bc10f20f22f2b67cabc",
  "2021": "6034ef71d8dec08691de396c",
  "2020": "5e4c0ca2587dbb32a10a4363",
  "2019": "5c6bc184e7ae8f0e6a254b83",
  "2018": "5a7dc5e222abe310418a4bcb"
};

Vue.use(Vuex);

const processFileCache = filecache => {
  let newList = {};
  filecache.forEach(item => {
    newList["https://fabacademy.org" + item.url] = item;
  });

  return newList;
};

export default new Vuex.Store({
  state: {
    sessions: [],
    labs: [],
    errors: [],
    thumbs: {},
    cache: {},
    filecache: {}
  },
  mutations: {
    UPDATE_SESSIONS: (state, sessions) => {
      state.sessions = sessions;
    },
    UPDATE_LABS: (state, labs) => {
      state.labs = labs;
    },
    UPDATE_FILECACHE: (state, cache) => {
      state.filecache = cache;
    },
    UPDATE_THUMBS: (state, thumbs) => {
      state.thumbs = thumbs;
    },
    API_ERROR: (state, error) => {
      state.errors = [...state.errors, error];
    }
  },
  actions: {
    checkFileURL: async ({ state }, url) => {
      // try {
      //   // console.log('Checking ' + url)
      //   if (state.cache[url]) {
      //     return state.cache[url];
      //   }
      //   const response = await axios.post(FILE_EXISTS_URL, { url: url });
      //   const payload = response.data;
      //   // console.log(payload)
      //   state.cache[url] = payload;
      //   return payload;
      // } catch (e) {
      //   commit(API_ERROR, e);
      // }
      // console.log("Checking " + url);
      if (state.filecache[url]) {
        // console.log("Found");
        return { success: true, url: url, status: 200 };
      }
      return { success: false, status: 500 };
    },
    fetchThumbnail: async ({ commit }, url) => {
      try {
        const response = await axios.post(THUMB_URL, { url: url });
        const payload = response.data;
        if (payload.success) {
          payload.url = API_ENDPOINT + payload.url;
        }

        return payload;
      } catch (e) {
        commit(API_ERROR, e);
        return { error: e };
      }
    },
    loadSessions: async ({ commit }, year = "2018") => {
      try {
        const response = await axios.get(
          SESSIONS_URL + "?course_id=" + IDS[year]
        );
        const payload = response.data;
        if (payload.success) {
          commit(UPDATE_SESSIONS, payload.data);
          if (payload.file_cache) {
            const fileCache = processFileCache(payload.file_cache);
            commit(UPDATE_FILECACHE, fileCache);
          }
        } else {
          commit(API_ERROR, payload.error);
        }
      } catch (e) {
        commit(API_ERROR, e);
      }
    },
    loadLabs: async ({ commit }, year = "2018") => {
      try {
        const response = await axios.get(LABS_URL + "?course_id=" + IDS[year]);
        const payload = response.data;
        if (payload.success) {
          if (payload.file_cache) {
            const fileCache = processFileCache(payload.file_cache);
            commit(UPDATE_FILECACHE, fileCache);
          }
          commit(UPDATE_LABS, payload.data);
        } else {
          commit(API_ERROR, payload.error);
        }
      } catch (e) {
        commit(API_ERROR, e);
      }
    }
  },
  getters: {
    years: () => Object.keys(IDS).reverse(),
    defaultYear: (state, getters) => getters.years[0],
    sessions: state => state.sessions,
    labs: state => state.labs
  }
});
